<template>
  <div>
    <div class="hidden-sm-and-down">
      <!-- <div class="fill-height bottom-gradient"> -->
      <v-card
        class="mx-auto overtile bottom-gradient rounded-0 pa-10"
        :outlined="getOutlined"
        :min-height="getHeight"
        color="#37383A"
        dark
        :style="[
          quoteSet.withImage
            ? {
                backgroundImage:
                  'linear-gradient(rgba(23, 101, 179,.3),rgba(44, 62, 80,9)), url(' +
                  quoteSet.img.url +
                  ')',
                backgroundSize: 'cover',
              }
            : { background: '#37383A' },
        ]"
      >
        <div class="" v-bind:key="quote.id" v-for="quote in quoteSet.quotes">
          <v-container>
            <v-icon size="20" color="#cccccc" class="mark pt-6 pb-4"
              >fas fa-quote-left</v-icon
            >
            <v-row
              class="quoteLine text-left"
              v-bind:key="line.id"
              v-for="line in quote.quoteLines"
            >
              <v-col
                v-if="line.speaker"
                cols="3"
                class="author text-left text-uppercase"
                >{{ line.speaker }}</v-col
              >
              <v-col v-if="line.text" class="line text-left">{{
                line.text
              }}</v-col>
            </v-row>
            <!-- <v-icon size=20 color='rgb(169, 169, 169)' class="mark pt-6 pb-4 text-right">fas fa-quote-right</v-icon> -->
          </v-container>
          <v-card-text class="author text-right text-uppercase">{{
            quote.author
          }}</v-card-text>
        </div>
      </v-card>
      <!-- </div> -->
    </div>
    <div class="hidden-md-and-up">
      <v-card
        class="mx-auto pa-4 pa-sm-6 overtile rounded-0"
        min-height="300"
        color="#37383A"
        dark
        :outlined="getOutlined"
      >
        <v-icon size="40" color="#1765B3" class="mark pt-6 pb-4"
          >fas fa-quote-left</v-icon
        >
        <div v-bind:key="quote.id" v-for="quote in quoteSet.quotes">
          <v-container class="pt-0 pb-0" fluid>
            <!-- <v-layout wrap> -->
            <v-row
              class="quoteLine text-left"
              v-bind:key="line.id"
              v-for="line in quote.quoteLines"
            >
              <v-col
                v-if="line.speaker"
                cols="3"
                class="pl-0 pr-0 author text-left text-uppercase"
                >{{ line.speaker }}</v-col
              >
              <v-col v-if="line.text" class="line">{{ line.text }}</v-col>
            </v-row>
            <!-- </v-layout> -->
          </v-container>
          <v-card-text class="author text-right text-uppercase">{{
            quote.author
          }}</v-card-text>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuoteTile",
  props: ["quoteSet"],
  computed: {
    getOutlined() {
      return new Boolean(false);
    },
    getHeight() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 350 : 400;
    },
    getWidth() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 400 : 800;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap");
@import "~vuetify/src/styles/settings/_variables.scss";

.overtile {
  position: relative;
  bottom: -130px;
  overflow: overlay;
  margin-top: -130px;
  box-shadow: -26px 29px 13px -6px rgba(0, 0, 0, 0.6);
}

// .fa-quote-left  {
// color: salmon;
// }

.line {
  letter-spacing: 0.1rem;
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    font-weight: bold;
  }
}

.quoteLine {
  font-family: "Fauna One", serif;
  font-size: 0.8rem;

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    font-size: 1.2rem;
  }
  @media #{map-get($display-breakpoints, 'sm-only')} {
    font-size: 1rem;
  }
}
.author {
  color: rgb(169, 169, 169) !important;
  // color: #F2EFE8;
  font-weight: bold;
  font-family: "Teko", sans-serif;
  font-size: 1rem;
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    font-size: 1.4rem;
  }
  @media #{map-get($display-breakpoints, 'sm-only')} {
    font-size: 1.2rem;
  }
}

.bottom-gradient {
  background-image: repeating-linear-gradient(
    45deg,
    rgba(55, 56, 58, 0.5),
    rgba(44, 62, 80, 0.5) 5px,
    rgba(23, 101, 179, 0.5) 5px,
    rgba(23, 101, 179, 0.5) 10px
  );
}
</style> 